module.exports = __webpack_public_path__ + "media/images/glasses-015f41e04be1e416df278b848747855b.svg";